import queryString from 'query-string'
import { usingGet, usingPost } from '@ocean/api'
import { RangePeriod } from 'components/common/BigCalendar/types'
import { BASE_API_SCHEDULE_PATH } from 'modules/virtualClassrooms/common/helpers'
import {
  AddVirtualEventWaitListPersonsModel,
  RemoveVirtualEventWaitListPersonsModel,
} from 'modules/virtualClassrooms/common/types/waitList'
import { AddVirtualEventScheduleWithEnrollmentsModel } from 'modules/virtualClassrooms/manager/Schedules/types/creator'
import {
  UpdateScheduleModel,
  AddScheduleEnrolledPersonsModel,
  RemoveScheduleEnrolledPersonsModel,
} from 'modules/virtualClassrooms/manager/Schedules/types/editor'

export const getListVirtualEventSchedules = (eventId: Guid, range?: RangePeriod) => {
  let queryParams = ''

  if (range) {
    const rangeParams = queryString.stringify(range, { skipNull: true })
    queryParams = `?${rangeParams}`
  }

  return usingGet(`virtualevents/event/${eventId}/scheduleDetails/list${queryParams}`, {
    useProxy: true,
  })
}

export const getListSchedules = (range: RangePeriod) => {
  const queryParams = queryString.stringify(range, { skipNull: true })
  return usingGet(`virtualevents/schedule/list?${queryParams}`, {
    useProxy: true,
  })
}

export const getListSchedulesForCalendar = (range: RangePeriod, timeZone: String) => {
  const queryParams = queryString.stringify(range, { skipNull: true })
  return usingGet(`virtualevents/schedule/listForCalendar?${queryParams}&timezone=${timeZone}`, {
    useProxy: true,
  })
}

export const getVirtualEventSchedule = (scheduleId: Guid) =>
  usingGet(`VirtualEvents/GetVirtualEventSchedule?scheduleId=${scheduleId}`)

export const getVirtualEventScheduleForCalendar = (scheduleId: Guid) =>
  usingGet(`VirtualEvents/GetVirtualEventScheduleForCalendar?scheduleId=${scheduleId}`)

export const updateVirtualEventSchedule = (params: UpdateScheduleModel) =>
  usingPost(`${BASE_API_SCHEDULE_PATH}/update`, params, {
    useProxy: true,
  })

export const getListVirtualEventRoomSettings = () =>
  usingGet('VirtualEvents/ListVirtualEventRoomSettings')

export const addVirtualEventScheduleWithEnrollments = (
  params: AddVirtualEventScheduleWithEnrollmentsModel
) => usingPost('VirtualEvents/AddVirtualEventScheduleWithEnrollments', params)

export const getListVirtualEventScheduleEnrolledPersons = (scheduleId: Guid) =>
  usingGet(`VirtualEvents/ListVirtualEventScheduleParticipants?scheduleId=${scheduleId}`)

export const addVirtualEventScheduleEnrolledPersons = (params: AddScheduleEnrolledPersonsModel) =>
  usingPost(`${BASE_API_SCHEDULE_PATH}/assignVirtualEventScheduleParticipants`, params, {
    useProxy: true,
  })

export const removeVirtualEventScheduleEnrolledPersons = (
  params: RemoveScheduleEnrolledPersonsModel
) => usingPost(`VirtualEvents/UnassignVirtualEventScheduleParticipants`, params)

export const getListVirtualEventWaitListPersons = (eventId: Guid) =>
  usingGet(`virtualevents/event/${eventId}/waitlist`, { useProxy: true })

export const addVirtualEventWaitListPersons = (params: AddVirtualEventWaitListPersonsModel) =>
  usingPost(`VirtualEvents/AssignVirtualEventWaitListParticipants`, params)

export const removeVirtualEventWaitListPersons = (params: RemoveVirtualEventWaitListPersonsModel) =>
  usingPost(`VirtualEvents/UnassignVirtualEventWaitListParticipants`, params)

export const publishVirtualEventSchedule = (scheduleId: Guid) =>
  usingPost(
    `${BASE_API_SCHEDULE_PATH}/publish`,
    { scheduleId },
    {
      useProxy: true,
    }
  )

export const cancelVirtualEventSchedule = (scheduleId: Guid) =>
  usingPost(
    `${BASE_API_SCHEDULE_PATH}/cancel`,
    { scheduleId },
    {
      useProxy: true,
    }
  )
